export const delay = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function waitWhile(callback: () => boolean): Promise<void> {
  if (callback()) {
    return
  }
  await new Promise<void>((resolve) => {
    const check = () => {
      if (callback()) {
        resolve()
      } else {
        setTimeout(check, 50)
      }
    }
    check()
  })
}

export async function clarityReady(): Promise<void> {
  await waitWhile(() => typeof window.clarity === 'function')
}
